import React, { Component } from 'react';

export class Team extends Component {
  render () {
    return (
      <div id='team' className='text-center'>
        <div className='container'>
          <div className='col-md-8 col-md-offset-2 section-title'>
            <h2>Meet the Team</h2>
            <p>We are a couple of passionate young entrepreneurs with a deep background in Machine Learning and Natural Language Processing</p>
          </div>
          <div id='row'>
            {this.props.data ? this.props.data.map(d =>
              <div className='col-md-6 col-md 2 team' key={d.name + 'team-key'}>
                <div className='thumbnail'> <img style={{ borderRadius: '50%' }} src={d.img} alt='...' className='team-img' />
                  <div className='caption'>
                    <h4><a href={d.linkedin} target='_blank'>{d.name}</a></h4>
                    <p>{d.job}</p>
                  </div>
                </div>
              </div>

            ) : 'loading'}

          </div>
        </div>
      </div>
    );
  }
}

export default Team;
